import React from 'react';
export default function UserStatusBadge({ status }) {
  return <span className={'inline-flex items-center gap-1.5 rounded border px-2.5 py-1 text-xs font-medium ' +
    (status === 'ACTIVE' ? 'border-emerald-100 bg-emerald-50 text-emerald-700' : 'border-slate-200 bg-slate-100 text-slate-600')}>
    <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />
    {status === 'ACTIVE' ? 'Active' : status === 'INACTIVE' ? 'Inactive' : status || 'Unknown'}
  </span>;
}
